import React from 'react';

const GlobalFooter: React.FC = () => {
  return (
    <footer className="bg-dark text-light py-3 mt-5">
      <div className="container">
        <div className="text-center">
          <small className="text-light">
            Powered by <strong className="text-white">TBI</strong>
          </small>
        </div>
      </div>
    </footer>
  );
};

export default GlobalFooter;
